import ElementUI from 'element-ui'

export default {
  watch: function (axios, store) {
    // Add a request interceptor
    axios.interceptors.request.use(function (config) {
      store.commit('app/tasks/add', {
        name: config.method.toUpperCase() + ' ' + config.url
      })
      return config
    }, function (error) {
      return Promise.reject(error)
    })

    // Add a response interceptor
    axios.interceptors.response.use(function (response) {
      store.commit('app/tasks/end', {
        name: response.config.method.toUpperCase() + ' ' + response.config.url
      })
      return response
    }, function (error) {
      if (error.response) {
        store.commit('app/tasks/end', {
          name: error.response.config.method.toUpperCase() + ' ' + error.response.config.url
        })
      }

      return Promise.reject(error)
    })
  }
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/services/axios-tasks.js